module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"attach":"Подключен","size":"Размер","type":"Тип диска","os":"Источник","name":"Тип конфигурации","cpu":"vCPU","ram":"Память"}}')
  delete Component.options._Ctor
}
